// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';

import 'vant/lib/index.css';
import './assets/global.css'
import globalVariable from './api/global_variable';
import VueClipboard from 'vue-clipboard2'
import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs;//可以全局使用dayjs
import ModalLoading from "@/components/Loading/index.js";
Vue.use(ModalLoading)

Vue.use(VueClipboard)

Vue.use(Vant);

Vue.use(ViewUI);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.baseUrl = globalVariable;//全局注册
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js